<app-centre-small-opener>
  <h2 mat-dialog-title dialogTitle class="title mar-b-5">Preview Minutes</h2>
  <div mat-dialog-content contentContainer class="row" [ngStyle]="{'overflow':'hidden'}">
   <div actions class="d-flex col-lg-12 col-sm-12 flex-wrap" [ngStyle]="{'margin-bottom':'10px', 'padding':'0px'}">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 justify-content-xl-end justify-content-lg-end justify-content-md-end justify-content-sm-end justify-content-end" [ngStyle]="{'padding':'0px'}" [style.display]="(momList!=null && momList!=undefined && momList!.length>1) ? 'block' : 'none'" >
          <mat-form-field [ngStyle]="{'width':'100%'}">
            <mat-label>Select MOM</mat-label>
            <mat-select disableOptionCentering panelClass="common-drop-down-class" [(ngModel)]="selectedValue" name="momSelect"   (selectionChange) = "checkForPreview()">
              <mat-option [value]="'select'">Select</mat-option>
              <ng-container *ngFor="let momLst of momList">
                <mat-option [value]="momLst.pkMomDetailId" *ngIf="momLst.momStatusCode!='A'" (click) = getMomId(momLst)>
                  {{momLst.momTitle}}
                </mat-option>
            </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-end">
          <button *ngIf = "showSendDraftButton == 'Y' && showResendDraftButton == 'N'" mat-raised-button actions color = "primary" class="button-container mar-l-8" [hidden]="isEmptyMomCont || selectedValue=='select'" (click) = "sendMoMDraft()">
            SEND
          </button>
          <button *ngIf = "showSendDraftButton == 'N' && showResendDraftButton == 'Com'" mat-raised-button actions color = "primary" class="button-container mar-l-8" [hidden]="isEmptyMomCont || selectedValue=='select'" (click) = "sendMoMDraft()">
            RESEND
          </button>
          <button mat-raised-button mat-dialog-close type="reset" color = "primary" actions class="button-container mar-l-8" id = "resetbtn">
            CANCEL
          </button>
        </div>
      </div> 
      <div class="loading-indicator">
        <mat-progress-spinner mode="indeterminate"  *ngIf="showLoading" bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
      </div>
      <div class="col-lg-12 col-sm-12" [ngStyle]="{'padding':'0px', 'height':'84vh'}">
            <iframe id="previewMinutes" [hidden]="isEmptyMomCont" src="" [ngStyle]="{'height':'58vh'}" type="application/pdf" width="100%" height="100vh"></iframe>
      </div>
  </div>
</app-centre-small-opener>